import { createConfig, configureChains, WagmiConfig, Chain } from 'wagmi'
import { mainnet, sepolia } from 'wagmi/chains'
import { infuraProvider } from 'wagmi/providers/infura'
import { InjectedConnector } from 'wagmi/connectors/injected'
import { MetaMaskConnector } from 'wagmi/connectors/metaMask'
import { WalletConnectConnector } from 'wagmi/connectors/walletConnect'
import config from '../../config'
import React from 'react'

const isProduction = import.meta.env.MODE === 'production'
const selectedChains: Chain[] = isProduction ? [mainnet] : [sepolia]
const { chains, publicClient, webSocketPublicClient } = configureChains(selectedChains, [
  infuraProvider({ apiKey: config.crypto.infuraApiKey }),
])

export const wagmiConfig = createConfig({
  publicClient,
  webSocketPublicClient,
  autoConnect: true,
  connectors:
    'ethereum' in window
      ? [new InjectedConnector({ chains })]
      : [
          new MetaMaskConnector({ chains }),
          new WalletConnectConnector({
            chains,
            options: {
              projectId: config.crypto.walletConnectId,
              qrModalOptions: {
                enableExplorer: false,
                explorerRecommendedWalletIds: 'NONE',
              },
            },
          }),
        ],
})

export const WagmiProvider = ({ children }: { children: React.ReactNode }) => {
  return <WagmiConfig config={wagmiConfig}>{children}</WagmiConfig>
}
